module.exports = __webpack_public_path__ + "img/Martinique.fdb2f3d3.svg";